export default "__VITE_ASSET__DVNd2Hz4__"